/*
 * @Description: 通用mixins
 * @Author: yangguang
 * @Date: 2022-03-07 22:41:42
 * @LastEditors: yangguang
 * @LastEditTime: 2022-03-07 23:41:24
 */
export default {
  // 路由跳转
  methods: {
    linkTo(name, params = {}, query = {}) {
      this.$router.push({
        name,
        params,
        query
      })
    },
    linkToNewTab(name, params = {}, query = {}) {
      // 使用路由的 resolve 方法获取完整路径
      const routeData = this.$router.resolve({
        name,
        params,
        query
      });

      // 在新标签页打开
      window.open(routeData.href, '_blank');
    },

    parseTime(timeStamp, separator = '-') {
      const date = new Date(timeStamp)
      const year = date.getFullYear()
      const month = `${date.getMonth() + 1}`.padStart(2, '0')
      const day = `${date.getDate()}`.padStart(2, '0')
      const hour = `${date.getHours()}`.padStart(2, '0')
      const minute = `${date.getMinutes()}`.padStart(2, '0')
      const second = `${date.getSeconds()}`.padStart(2, '0')

      return {
        ymdhms: `${year}${separator}${month}${separator}${day} ${hour}:${minute}:${second}`,
        ymd: `${year}${separator}${month}${separator}${day}`,
        hms: ` ${hour}:${minute}:${second}`
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/utils.js